import { Search } from '@/components/ui/icons';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { searchBarStyles } from './SearchBar.styles';

export type SearchBarProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showIcon?: boolean;
};

export function SearchBar({
  className,
  value,
  onChange,
  showIcon = true,
  ...props
}: SearchBarProps): JSX.Element {
  return (
    <div className={searchBarStyles.root}>
      {showIcon ? (
        <Search
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-brand-700"
          aria-hidden
        />
      ) : null}
      <input
        type="search"
        value={value}
        onChange={onChange}
        className={cn(searchBarStyles.field, !showIcon && 'pl-4', className)}
        {...props}
      />
    </div>
  );
}
